
<template>

<div>

  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title has-text-centered">Here's what I've done so far
        </h1>

        <div v-for="w in resume.work" :key="w" class="columns">
          <div class="column"/>
              <div class="column is-one-quarter"><img :src="'/assets/' + w.logo"></div>
              <div class="column is-three-quarters">
                <div class="is-size-3 has-text-primary">{{w.company}}</div>
                <div class="is-size-5 has-text-grey-light">{{w.position}}, <span :v-if="w.endDate">{{w.startDate}} - {{w.endDate}}</span>  </div>
                <div class="is-size-6 has-text-dark">{{w.location}}</div>
                <div v-for="highlight in w.highlights" :key="highlight">
                  <p class="mt-2 lead is-size-6">{{highlight}}</p>
                </div>
                <ul class="list-inline mt-2">
                    <li class="list-inline-item" v-for="t in w.tags" :key="t">
                      <div class="tag is-primary">{{t}}</div>
                    </li>
                </ul>
              </div>
          <div class="column"></div> 
        </div>

        <div v-for="e in resume.education" :key="e" class="columns">
          <div class="column"/>
              <div class="column is-one-quarter"><img :src="'/assets/' + e.logo"></div>
              <div class="column is-three-quarters">
                <div class="is-size-3 has-text-primary">{{e.institution}}</div>
                <div class="is-size-5 has-text-grey-light">{{e.area}}, {{e.endDate}} </div>
                <div class="is-size-6 has-text-dark">{{e.location}}</div> 
              </div>
          <div class="column"></div> 
        </div>

      </div>
    </div>
  </section>

</div>

</template>

<script>
import json from './../assets/resume.json';

export default {
  name: 'Resume',
  data() {
    return {
      resume: {},
      message: ''
    }
  },
  created () {
    this.loadResume();
  },
  methods: {
    async getResume() {
      return new Promise(resolve => {
        resolve(json)
      });
    },
    async loadResume(){
      this.resume = {};
      this.resume = await this.getResume();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
